import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { standards, trustPillars } from '../data/siteData';
import './TrustBar.css';

const TrustBar = () => (
  <section className="section trust-section">
    <div className="container trust-layout">
      <div className="trust-copy">
        <p className="eyebrow">Compliance support</p>
        <h2 className="section-title">Documentation that keeps procurement calm.</h2>
        <p className="section-sub">
          NovaCareLinens keeps compliance documentation, product specifications,
          and audit support close to every account so facility teams are not
          chasing paperwork after a shipment lands.
        </p>
        <Link className="btn-secondary" to="/compliance">
          Review standards <ArrowRight size={18} aria-hidden="true" />
        </Link>
      </div>

      <div className="trust-card surface-card">
        <div className="trust-standard-row">
          {standards.map(({ code, Icon, tone }) => (
            <div className="trust-standard" key={code}>
              <span className={`icon-circle tone-${tone}`}>
                <Icon size={21} strokeWidth={1.8} aria-hidden="true" />
              </span>
              <strong>{code}</strong>
            </div>
          ))}
        </div>
        <div className="trust-pillar-grid">
          {trustPillars.map(({ title, text, Icon }, index) => (
            <article key={title} style={{ '--delay': `${index * 80}ms` }} className="stagger-card">
              <Icon size={20} strokeWidth={1.8} aria-hidden="true" />
              <div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default TrustBar;
